module.exports = __webpack_public_path__ + "img/img_finished_sign_up.77f21173.svg";